import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ConfirmationModalProps } from '@frontend/design-system';

type DeleteCallRecordingModalProps = Pick<ConfirmationModalProps, 'show' | 'onClose' | 'onConfirm'> &
  Partial<Pick<ConfirmationModalProps, 'title' | 'message' | 'cancelLabel' | 'confirmLabel' | 'maxWidth'>>;

const modalStyles = css`
  min-height: 208px;
`;

export const DeleteCallRecordingModal = ({
  show,
  onClose,
  onConfirm,
  title,
  message,
  cancelLabel,
  confirmLabel,
  maxWidth = 600,
}: DeleteCallRecordingModalProps) => {
  const { t } = useTranslation('calls');

  return (
    <ConfirmationModal
      show={show}
      onClose={onClose}
      title={title ?? t('Delete Call Recording?')}
      message={message ?? t('Are you sure you want to delete this Call Recording?')}
      destructive
      cancelLabel={cancelLabel ?? t('No, Cancel')}
      confirmLabel={confirmLabel ?? t('Yes, Delete')}
      maxWidth={maxWidth}
      modalCss={modalStyles}
      onConfirm={onConfirm}
    />
  );
};
